import { render, staticRenderFns } from "./RecipeLabel.vue?vue&type=template&id=8b851d1c&scoped=true&"
import script from "./RecipeLabel.vue?vue&type=script&lang=js&"
export * from "./RecipeLabel.vue?vue&type=script&lang=js&"
import style0 from "./RecipeLabel.vue?vue&type=style&index=0&id=8b851d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b851d1c",
  null
  
)

export default component.exports